import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';

const AliasDeleteDialog = ({open, alias, saving, onCancel, onConfirm}) => (
    <Dialog open={open} onClose={saving ? undefined : onCancel} maxWidth="xs" fullWidth>
        <DialogTitle>Delete alias</DialogTitle>
        <DialogContent>
            <DialogContentText>
                Are you sure you want to delete {alias ? `"${alias}"` : 'this alias'}?
                This action cannot be undone.
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={onCancel} disabled={saving}>Cancel</Button>
            <Button onClick={onConfirm} color="error" variant="contained" disabled={saving}>
                {saving ? 'Deleting...' : 'Delete'}
            </Button>
        </DialogActions>
    </Dialog>
);

export default AliasDeleteDialog;
